module.exports = __webpack_public_path__ + "media/img/features/front-page-spanish-large-dce253c0831fc5e9f38c2a930a18acd4.png";